import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Center,
  Container,
  HStack,
  Heading,
  List,
  ListItem,
  Text,
} from '@chakra-ui/react';
import PageHeader from 'components/page-header/PageHeader';
import PageTitleMobile from 'components/page-header/PageTitleMobile';
import { withIronSessionSsr } from 'iron-session/next';
import RootLayout from 'layouts/RootLayout';
import { sessionOptions } from 'libs/iron-session';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Head from 'next/head';
import { NextPageWithLayout } from './_app';
import Image from 'next/image';

const HowToPayPage: NextPageWithLayout = () => {
  return (
    <>
      <Head>
        <title>การชำระเงิน | แลมป์ตั้น</title>
      </Head>
      <Box>
        <PageHeader title={`การชำระเงิน`}></PageHeader>
        <PageTitleMobile>{`การชำระเงิน`}</PageTitleMobile>
        <Container
          pt={{
            base: 8,
            md: 12,
          }}
          pb={{
            base: 8,
            md: 20,
          }}
        >
          <Text mb={4}>
            เพื่ออำนวยความสะดวกให้กับลูกค้าของเรา
            ท่านสามารถชำระเงินได้หลากหลายช่องทาง
          </Text>
          <Accordion defaultIndex={[]} allowMultiple>
            <AccordionItem borderColor="#eee">
              <AccordionButton
                py={4}
                width="100%"
                display="flex"
                justifyContent="flex-start"
              >
                <HStack spacing={4} width="100%">
                  <Center flex="0 0 60px">
                    <Image
                      src="/image-icon/credit-card.png"
                      width={40}
                      height={30}
                      alt="credit-card"
                    ></Image>
                  </Center>
                  <Text flex="1" textAlign="left">
                    เครดิต / เดบิต (ชำระเต็มจำนวน)
                  </Text>
                </HStack>
              </AccordionButton>
              <AccordionPanel pb={4}>
                <Text color="gray.600" mb={5}>
                  LAMPTAN Shop Online รองรับบัตรเครดิต Visa, MasterCard cards,
                  JCB, และ Union Pay (สำหรับบัตรในประเทศ) LAMPTAN Store Online
                  จะใช้รหัสเครื่องหมายรับรองความปลอดภัยทางอิเล็กทรอนิกส์ หรือ
                  Secure Sockets Layer (SSL)
                  เพื่อให้ลูกค้ามั่นใจว่าการชำระเงินและการปรับเปลี่ยน
                  แก้ไขข้อมูลส่วนตัวนั้น เป็นไปอย่างปลอดภัย ข้อมูลสำคัญต่าง ๆ
                  เช่น ข้อมูลของบัตรเครดิต และข้อมูลส่วนตัว (ชื่อ,ที่อยู่
                  และอื่น ๆ) จะถูก เก็บรักษาไว้เป็นความลับ
                  บุคคลอื่นไม่สามารถเข้าถึงข้อมูลได้โดยไม่ได้รับอนุญาต
                </Text>
                <Text color="gray.600" mb={5}>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ลูกค้าสามารถใช้บัตรเดบิตได้ทั้ง
                  Visa, MasterCard cards, JCB, และ Union Pay
                  (สำหรับบัตรในประเทศ) ในการซื้อสินค้ากับLAMPTAN Store Online
                  อาจจะใช้ได้กับบางธนาคารที่มีระบบรองรับการซื้อสินค้าออนไลน์
                  โปรดติดต่อกับธนาคารเจ้าของบัตรเพื่อทำการเปิดใช้งานระบบการซื้อสินค้าออนไลน์
                </Text>
                <Text color="gray.600" mb={5}>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;คุณจำเป็นต้องใส่รหัสผ่านที่ใช้ครั้งเดียว
                  (OTP) ที่ได้รับผ่านทางธนาคารเจ้าของบัตร
                </Text>
              </AccordionPanel>
            </AccordionItem>

            <AccordionItem borderColor="#eee">
              <h2>
                <AccordionButton
                  py={4}
                  width="100%"
                  display="flex"
                  justifyContent="flex-start"
                >
                  <HStack spacing={4} width="100%">
                    <Center flex="0 0 60px" pl={2}>
                      <Image
                        src="/image-icon/bank-transfer.png"
                        width={34}
                        height={20}
                        alt="bank-transfer"
                      ></Image>
                    </Center>
                    <Text>โอนเงินผ่านธนาคาร</Text>
                  </HStack>
                </AccordionButton>
              </h2>
              <AccordionPanel pb={4}>
                <Box pl={8} mb={10} mt={4}>
                  <HStack spacing={4} mb={4}>
                    <Image
                      src="/image-icon/mobile-banking.png"
                      width={34}
                      height={22}
                      alt="credit-card"
                    ></Image>
                    <Text fontWeight={400}>
                      INTERNET BANKING โดยระบบการโอนเงิน/ชำระบิล มีขั้นตอนดังนี้
                    </Text>
                  </HStack>
                  <Text>1. ล็อกอินเข้าระบบ iBanking</Text>
                  <Text>2. เลือกเมนู “จ่ายบิล”</Text>
                  <Text>
                    3. ค้นหาชื่อบริษัทผู้รับชำระ โดยใส่ “บริษัท 123 เซอร์วิส
                    จำกัด”
                  </Text>
                  <Text>
                    4. ใส่ Payment Code Ref.1 หมายเลขอ้างอิง1 จำนวน 10 หลัก{' '}
                  </Text>
                  <Text>
                    5. ใส่ หมายเลขโทรศัพท์มือถือ Ref.2 หมายเลขอ้างอิง2{' '}
                  </Text>
                  <Text>6. ระบุจำนวนเงินให้ถูกต้อง</Text>
                  <Text>7. เลือก “ต่อไป” </Text>
                  <Text>8. ตรวจสอบความถูกต้องและ กด “ยืนยัน”</Text>
                </Box>
                <Box pl={8} mb={10}>
                  <HStack spacing={4} mb={4}>
                    <Image
                      src="/image-icon/mobile-qr.png"
                      width={34}
                      height={22}
                      alt="credit-card"
                    ></Image>
                    <Text fontWeight={400}>ชำระผ่าน QR Code</Text>
                  </HStack>
                  <Text>
                    ลูกค้าสามารถชำระสินค้าได้ง่ายยิ่งขึ้น เพียงใช้ Mobile
                    application ของธนาคารใดก็ได้ สแกน QR Code โดยไม่มียอดขั้นต่ำ
                    ระบบจะแสดงยอดสั่งซื้ออัตโนมัติเพื่อความปลอดภัย ในการชำระเงิน
                    โดยไม่ ต้องให้ข้อมูลบัตรเครติดหรือข้อมูลใด ๆ เพิ่มเติ่ม
                    (การชำระเงิน QR Code ควรสแกนชำระภายในเวลาที่กำหนด)
                  </Text>
                  <Text>
                    สแกนบาร์โค้ดหรือคิวอาร์โค้ดด้วย MOBILE BANKING APPLICATION
                    มีขั้นตอนดังนี้
                  </Text>
                  <Text>
                    1. ล็อกอินเข้าระบบ mBanking ผ่าน application บนมือถือ
                  </Text>
                  <Text>2. เลือกเมนู “ชำระเงิน / จ่ายบิล”</Text>
                  <Text>3. เลือกเมนู “สแกนบิล”</Text>
                  <Text>4. สแกนคิวอาร์โค้ด</Text>
                  <Text>5. ตรวจสอบรายการ / เลือก “ต่อไป”</Text>
                  <Text>6. กด “ยืนยัน”</Text>
                  <Text>7. ทำรายการสำเร็จ</Text>
                </Box>
                <Box pl={8}>
                  <HStack spacing={4} mb={4}>
                    <Image
                      src="/image-icon/printer.png"
                      width={34}
                      height={22}
                      alt="credit-card"
                    ></Image>
                    <Text fontWeight={400}>
                      สามารถพิมพ์ใบชำระเงินนี้และนำไปชำระเงินได้ตามช่องทางที่ท่านสะดวก
                    </Text>
                  </HStack>
                  <List listStyleType="initial" paddingLeft={6}>
                    <ListItem>ธนาคารกรุงเทพ</ListItem>
                    <ListItem>ธนาคารกสิกร</ListItem>
                    <ListItem>ธนาคารไทยพาณิชย์</ListItem>
                    <ListItem>ธนาคารกรุงไทย</ListItem>
                    <ListItem>ธนาคารกรุงศรีอยุธยา</ListItem>
                    <ListItem>
                      Cenpay ที่ Central, Robinson, Tops, B2S, Office Mate
                    </ListItem>
                    <ListItem>Big Service ที่ Big C</ListItem>
                    <ListItem>Lotus</ListItem>
                    <ListItem>MPay</ListItem>
                    <ListItem>Pay@post ที่ไปรษณีย์ไทย</ListItem>
                    <ListItem>
                      True Money Express และ True Money Wallet
                    </ListItem>
                    <ListItem>บุญเติม</ListItem>
                  </List>
                  <Text fontWeight={500}>
                    *ทางผู้รับชำระเงินอาจจะเรียกเก็บค่าธรรมเนียมเพิ่มเติมและมีกำหนดจำนวนเงินสูงสุดต่อบิล
                    ควรตรวจสอบค่าธรรมเนียมและเงื่อนไขการชำระของผู้ให้บริการนั้น
                    ๆ ก่อนใช้บริการ*
                  </Text>
                </Box>
              </AccordionPanel>
            </AccordionItem>

            {/* <AccordionItem borderColor="#eee">
              <AccordionButton
                py={6}
                width="100%"
                display="flex"
                justifyContent="flex-start"
              >
                <HStack spacing={4} width="100%">
                  <Center flex="0 0 60px">
                    <Image
                      src="/image-icon/grab-pay.png"
                      width={60}
                      height={30}
                      alt="grab"
                    ></Image>
                  </Center>
                  <Text>GRAB PAY</Text>
                </HStack>
              </AccordionButton>
            </AccordionItem> */}

            <AccordionItem borderColor="#eee">
              <AccordionButton
                py={4}
                width="100%"
                display="flex"
                justifyContent="flex-start"
              >
                <HStack spacing={4} width="100%">
                  <Center flex="0 0 60px">
                    <Image
                      src="/image-icon/truemoney.png"
                      width={60}
                      height={40}
                      alt="grab"
                    ></Image>
                  </Center>
                  <Text>TRUE MONEY</Text>
                </HStack>
              </AccordionButton>
            </AccordionItem>
          </Accordion>
        </Container>
      </Box>
    </>
  );
};

HowToPayPage.getLayout = (page) => {
  return <RootLayout>{page}</RootLayout>;
};

export const getServerSideProps = withIronSessionSsr(async function ({
  req,
  res,
  locale,
}) {
  const _locale = locale || 'th';

  return {
    props: {
      ...(await serverSideTranslations(_locale, ['common'])),
    },
  };
},
sessionOptions);

export default HowToPayPage;
